<template>
<div class="toutiao-page">
  <Swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <SwipeItem>
      <img src="@/assets/toutiao-download/Frame2362.png" alt="">
    </SwipeItem>
    <SwipeItem>
      <img src="@/assets/toutiao-download/Frame2363.png" alt="">
    </SwipeItem>
    <SwipeItem>
      <img src="@/assets/toutiao-download/Frame2364.png" alt="">
    </SwipeItem>
  </Swipe>
    <div class="footer">
      <div class="qr-code">
        <img src="@/assets/toutiao-download/qr_code.png" alt="">
        <p>现在就打开微信扫描二维码 <br>下载 <span>法临APP </span>吧～ </p>
      </div>
      <div class="btn" @click="download"></div>
      <div class="tip">
        <img src="@/assets/toutiao-download/Frame2241@2x.png" alt="">
      </div>
    </div>
</div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
import {downloadPic} from "@/libs/tool.js";
export default {
  name: "index",
  components:{
    Swipe,
    SwipeItem
  },
  methods:{
    download(){
      downloadPic('https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png')
    }
  }
}
</script>

<style scoped lang="scss">
.toutiao-page{
  padding-bottom: 50px;
}
.my-swipe{
  img{
    width: 100%;
    height: 426px;
  }
  ::v-deep .van-swipe__indicators{
    bottom: 55px;
  }
}
.footer{
  border-radius: 23px 23px 0 0;
  background: white;
  overflow: hidden;
  margin-top: -22px;
  position: relative;
  z-index: 10;
}
.tip{
  text-align: center;
  padding-top: 10px;
  img{
    font-size: 0;
    width: 335px;
    height: 127px;
  }
}
.btn{
  width: 311px;
  height: 52px;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 500;
  background: url("~@/assets/toutiao-download/Frame2@2x.png");
  background-size: 100% 100%;
  text-align: center;
  z-index: 11;
}
.qr-code{
  display: flex;
  justify-content: center;
  padding-top: 21px;
  padding-bottom: 14px;
  align-items: center;
  img{
    width: 80px;
    height: 80px;
  }
  p{
    padding-left: 20px;
    font-size: 15px;
    font-weight: 500;
    span{
      color: #FF8A36;
    }
  }
}
</style>
